import { getSentry, getSentryVue } from '../lazy/sentry';

const SENTRY_DSN = process.env['VITE_SENTRY_DSN'];

export async function initSentry() {
  if (!SENTRY_DSN) {
    console.warn('Sentry DSN not found');
    return;
  }

  const Sentry = await getSentry();

  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: document?.location?.href.includes('language-rooms.com')
      ? 'production'
      : 'development',
  });

  const SentryVue = await getSentryVue();
  Sentry.addIntegration(SentryVue.replayIntegration());
  Sentry.addIntegration(SentryVue.replayCanvasIntegration());
}
